import React, { Fragment, useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Redirect, useHistory, useLocation } from "react-router-dom"

import {
  setTokens,
  fetchPrinters,
  fetchFoodTaxes,
  fetchCategories,
  fetchSystemSettings,
  fetchUserAccountInfo,
  fetchSystemBranches,
  fetchCustomerPrintTemplate,
  fetchFoodSpecifications,
  clearShift
} from "@redux"
import {
  clearSiteData,
  socketConnection,
  fetchFoodsInbackground
} from "utils"
import { getHaveOpenShift } from "services"
import { PageLoader, WarningPopup } from "components"
import { initApi } from "services/api"
import KcWelcomeLayer from "./KcWelcomeLayer"
import KcStartShift from "./KcStartShift"
import classes from "./index.module.scss"

const KioskContainer = (props) => {
  const dispatch = useDispatch()

  const history = useHistory()

  const location = useLocation()

  const shiftCashier =
    useSelector(state => state.shiftCashier)

  const { _id: accountId, branchId } =
    useSelector(state => state.userAccountInfo)

  const domain =
    useSelector(state => state.systemSettings.domain)

  const categories =
    useSelector(state => state.categories)

  const online =
    useSelector(state => state.internetStatus.online)

  const socketRef = useRef(null)

  const getAppData = () => {
    if (!online) return
    if (!branchId) return
    if (!accountId) return

    dispatch(fetchCategories())

    dispatch(fetchFoodSpecifications())

    dispatch(fetchFoodTaxes())

    fetchFoodsInbackground.start(branchId)

    dispatch(fetchCustomerPrintTemplate(branchId))

    dispatch(fetchPrinters())
  }

  const initialize = async () => {
    if (!online) return

    dispatch(fetchUserAccountInfo())

    dispatch(fetchSystemSettings())

    dispatch(fetchSystemBranches())
  }

  const haveOpenShift = async () => {
    if (!branchId) return

    if (!shiftCashier[accountId]) return

    const currentShiftId =
      shiftCashier[accountId]._id

    if (!currentShiftId) {
      dispatch(clearShift())

      clearSiteData()

      history.push("/kiosk-languages")

      return
    }

    const openShift =
      await getHaveOpenShift({ branchId })

    if (openShift?._id === currentShiftId) return

    dispatch(clearShift())

    clearSiteData()

    history.push("/kiosk-languages")
  }

  const setApiDomain = () => {
    const accessToken =
      localStorage.getItem("at")

    dispatch(
      setTokens({
        accessToken,
        refreshToken: ""
      })
    )

    initApi(domain)
  }

  useEffect(() => {
    setApiDomain()
  }, [])

  useEffect(() => {
    haveOpenShift()
  }, [accountId, branchId])

  useEffect(() => {
    initialize()
  }, [online])

  useEffect(() => {
    getAppData()
  }, [online, branchId, accountId])

  const disconnectSocketConnectionFromServer = () => {
    if (!socketRef.current) return

    socketRef.current.removeAllListeners()

    socketRef.current.disconnect()
  }

  useEffect(() => {
    if (online) {
      socketRef.current =
        socketConnection.createSocketConnectionToServer()
    } else {
      disconnectSocketConnectionFromServer()
    }
  }, [online])

  useEffect(() => {
    return () => {
      disconnectSocketConnectionFromServer()
    }
  }, [])

  const loading =
    categories === null

  const isLoggedIn =
    !!localStorage.getItem("at")

  const showStartShift =
    !!branchId &&
    !!shiftCashier[accountId]

  if (!isLoggedIn) return <Redirect to="/" />

  if (!accountId) return <PageLoader />

  if (!showStartShift) return <KcStartShift />

  if (loading) return <PageLoader />

  const removePaddings =
    location.pathname === "/kiosk-printer" ||
    location.pathname === "/kiosk-settings" ||
    location.pathname === "/kiosk-shift-cashier-history"

  if (removePaddings) return props.children

  return (
    <Fragment>
      <div className={classes["container"]}>
        {props.children}
      </div>

      <KcWelcomeLayer />

      <WarningPopup />
    </Fragment>

  )
}

export default KioskContainer